import axios from "axios";

const API = axios.create({ baseURL: `${process.env.REACT_APP_BASE_URL}` });

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token}`;
  }

  return req;
});

export const fetchPosts = (page) => API.get(`/posts/all?page=${page}`);
export const fetchPost = (id) => API.get(`/posts/${id}`);
export const comment = (value, id) => API.patch(`/posts/${id}/comment`, { value });
export const createPost = (newPost) => API.post("/posts", newPost);
export const updatePost = (id, updatedPost) => API.patch(`/posts/${id}`, updatedPost);
export const deletePost = (id) => API.delete(`/posts/${id}`);
export const likePost = (id) => API.patch(`/posts/${id}/like`);
export const fetchPostsBySearch = (searchQuery) =>
  API.get(`/posts/search?page=${searchQuery.page}&searchQuery=${searchQuery.search || "none"}&tags=${searchQuery.tags || "none"}`);

export const fetchSuggestedPosts = (searchQuery) => API.get(`/posts/suggestion?tags=${searchQuery.tags || "none"}`);

export const signIn = (formData) => API.post("/user/signin", formData);
export const signUp = (formData) => API.post("/user/signup", formData);
